export const randomize = (max) => {
    return Math.floor(Math.random() * max);
};



// WEBPACK FOOTER //
// ./components/logo/helpers.js